const INITIAL_STATE = {
  atestado: null,
  esperandoSolicitacao: false,
  alerta: {}
};

const MESSAGE_CONNECTION = 'Não foi possível se comunicar com nossos servidores, tente novamente mais tarde.';
export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_INICIAR_BUSCAR_ATESTADO_POR_CPF':
      return { ...state, alerta: {}, esperandoSolicitacao: true };
    case 'REQUERIMENTO_RECEBER_DADOS_ATESTADO_POR_CPF':
      return { ...state, esperandoSolicitacao: false, atestado: action.payload }
    case 'REQUERIMENTO_RECEBER_DADOS_ATESTADO_POR_CPF_ERROR':
      return { ...state, atestado: null, esperandoSolicitacao: false, alerta: { message: MESSAGE_CONNECTION, severity: 'error' } }
    default:
      return state;
  }
}
